import { render, staticRenderFns } from "./SatisfactionQuestionSurveySettings.vue?vue&type=template&id=6fc838dd"
import script from "./SatisfactionQuestionSurveySettings.vue?vue&type=script&lang=js"
export * from "./SatisfactionQuestionSurveySettings.vue?vue&type=script&lang=js"
import style0 from "./SatisfactionQuestionSurveySettings.vue?vue&type=style&index=0&id=6fc838dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports